import { useGetCompanySummary } from "../../../api/admin/company";
import HeadlessGenericDropdown, {
    DropdownItem,
} from "../HeadlessGenericDropdown";
import { ApiCompanySummary } from "../../../models/api/admin/company";

type CompanyDropdownProps = {
    handleCompanyChange: (company: ApiCompanySummary | null) => void;
    selectedCompany: ApiCompanySummary | null;
    showLabels?: boolean;
};
export default function CompanyDropdown({
    handleCompanyChange,
    selectedCompany,
    showLabels,
}: CompanyDropdownProps) {
    const { companySummary, companySummaryError, isLoadingCompanySummary } =
        useGetCompanySummary();

    const companyDropdownItems = companySummary?.items.map(
        (company: ApiCompanySummary) => ({
            item: company.companyName,
            id: company.companyId,
        })
    );

    const handleCompanySelect = (item: DropdownItem | null) => {
        const companyFromId: ApiCompanySummary | undefined =
            companySummary?.items.find(
                (company) => company.companyId === item?.id
            );
        if (companyFromId) handleCompanyChange(companyFromId);
    };
    return (
        <>
            {companySummary && (
                <HeadlessGenericDropdown
                    dropdownPlaceholder="All clients"
                    dropdownData={companyDropdownItems}
                    selectedItem={{
                        item: selectedCompany?.companyName,
                        id: selectedCompany?.companyId,
                    }}
                    handleItemChange={handleCompanySelect}
                    error={companySummaryError}
                    isLoading={isLoadingCompanySummary}
                    label={showLabels ? "Client" : undefined}
                />
            )}
        </>
    );
}
